import Base from "../../ts/_base";

export default class TrustedProxy extends Base {
    public initialize(): void {
        this.control();
    }

    protected control(): void {
        //@refactor
        $(document).on('change', '.trustedProxyUserId', function () {
            this.closest('form').submit();
        });
    }
}

